module.exports = __webpack_public_path__ + "static/media/21-beals-bonfire-10_10_2020.9bf1f0ce.JPG";